(function () {
  /**
   * @ngdoc module
   * @name app.core.invites.ready
   * @description sets up the invites logic
   */
  angular.module('app.core.invites.ready', [
    'app.core.invites',
    'binky.core.api.ready',
    'binky.core.invitation',
  ]);
})();
